import { Sparkle } from "lucide-react";

const WORDS = [
  "Sizzling Fajitas",
  "Hand-Pressed Tortillas",
  "Slow-Simmered Mole",
  "Fresh Lime Margaritas",
  "Family Recipes Since Day One",
  "Churros con Chocolate",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      className="relative overflow-hidden border-y border-terracotta/15 bg-clay-900 py-6"
      data-testid="marquee-section"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif-d text-2xl sm:text-3xl italic text-cream/40 whitespace-nowrap">
                  {w}
                </span>
                <Sparkle className="w-4 h-4 text-terracotta/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
